import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import { Provider } from 'react-redux';
import { store } from './app/store/store';

import App from './app/App';
import ErrorBoundary from './app/ErrorBoundary';

const auth0API = process.env.REACT_APP_AUTH0_AUTHORIZATION_API;
const clientId = process.env.REACT_APP_AUTH0_CLIENTID;

// MUI 그리드가 레이아웃을 조정할 때 브라우저가 흘리는 무해한 통지(다음 프레임으로
// 미뤄진 ResizeObserver 알림)가 개발 오버레이에 오류처럼 화면을 덮는 것을 막는다.
// 실제 오류가 아니라서 운영 동작과 무관하고, 그 밖의 오류는 그대로 표면화된다.
window.addEventListener('error', (event) => {
    if (event.message?.includes('ResizeObserver loop')) {
        event.stopImmediatePropagation();
    }
});

ReactDOM.createRoot(document.getElementById('root')).render(
    <ErrorBoundary>
        <Auth0Provider
            domain="insightshippinginc.us.auth0.com"
            clientId={clientId}
            authorizationParams={{
                // redirect_uri: 'http://localhost:3000',
                redirect_uri: window.location.origin,
                audience: auth0API,
            }}
            useRefreshTokens={true}
            cacheLocation="localstorage"
        >
            <Provider store={store}>
                <App />
            </Provider>
        </Auth0Provider>
    </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
